import MessageActionsDropdownButton from './MessageActionsDropdownButton';
import MessageActionsButton from './MessageActionsButton';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const ActionButtonComponent = ({
  children,
  onClick,
  collapsed,
  i18nButtonText,
  buttonIcon,
  tooltipProps,
  disabled,
  'data-test-id': dataTestId
}) => {
  if (collapsed) {
    return /*#__PURE__*/_jsxs(MessageActionsDropdownButton, {
      onClick: onClick,
      buttonIcon: buttonIcon,
      "data-test-id": dataTestId,
      tooltipProps: tooltipProps,
      disabled: disabled,
      children: [i18nButtonText, children]
    });
  } else {
    return /*#__PURE__*/_jsx(MessageActionsButton, {
      onClick: onClick,
      buttonIcon: buttonIcon,
      "data-test-id": dataTestId,
      disabled: disabled,
      tooltipProps: Object.assign({}, tooltipProps, {
        title: i18nButtonText
      })
    });
  }
};
ActionButtonComponent.displayName = 'ActionButtonComponent';
export default ActionButtonComponent;